var render = function render(){var _vm=this,_c=_vm._self._c;return _c('account-password-view',{attrs:{"error":_vm.error,"loading":_vm.loading},on:{"remove":_vm.remove,"send":_vm.change_password_local}})
}
var staticRenderFns = []

export { render, staticRenderFns }